import { BaseCustomGroup, BaseGroupItem, CustomGroupTypes } from './customGroup';
import { ParamValues, CustomReportSetWithResolvedReports, CustomReport } from './customReports';
import { Expression } from '@common/utils/evaluateExpression';
import { SftpSchedule } from '@common/types/sftpSchedule';

export enum BatchReportItemTypes {
  CUSTOM_REPORT = 'CR',
}

export type BatchReportItem = BaseGroupItem & {
  itemType: BatchReportItemTypes.CUSTOM_REPORT
};

export type BatchReport = BaseCustomGroup & {
  groupType: CustomGroupTypes.BATCH_REPORT,
  groupItem: BatchReportItem[],
  archivalFlag: boolean,
  sftpDeliveryFlag: boolean,
  role: String,
  privileges: String[],
}

const StandardReportNames = [
  'ViewAccountBalances',
  'ViewEffectiveTaxRate',
  'NewTaxExpense',
  'TaxExpense',
  'HistoricalTaxExpense',
  'ProvisionDetail',
] as const;

type StandardReportName = typeof StandardReportNames[number];

type StandardReportParam = {
  name: StandardReportName,
  type: 'select' | 'multiselect',
  label: string
  hideWhen?: Expression,
};


export type StandardReportDefinition = {
  reportSetId: string,
  reportName: string,
  reportLabel: string,
  params: Record<string, StandardReportParam>
}

export type CustomReportDefinition = CustomReportSetWithResolvedReports | CustomReport;

export type ReportDefinition = CustomReportDefinition | StandardReportDefinition;


export type BatchReportItemWithReportDetails = BatchReportItem & {
  reportDefinition: ReportDefinition
}

export type BatchReportDetails = Omit<BatchReport, 'groupItem'> & {
  groupItem: BatchReportItemWithReportDetails[]
}

type ReportName = string;

export type ReportParameters = {
  isIncludedInExport: boolean,
  reportParamValues: ParamValues,
  reportDefinition: ReportDefinition
}

export type BatchReportParameters = Record<ReportName, ReportParameters>;

export type BatchReportDefaultParams = {
  reports?: Record<string, unknown>;
  reportsForExport?: unknown[];
  companyCode?: string;
  exportFormat?: 'xlsx' | 'csv';
  sftpSchedule?: SftpSchedule;
};

export type { SftpSchedule } from '@common/types/sftpSchedule';


export const isCustomReport = (reportDefinition: any):
  reportDefinition is CustomReportSetWithResolvedReports | CustomReport => !!reportDefinition.customReportType;


export const isStandardReport = (reportDefinition: any):
reportDefinition is StandardReportDefinition => StandardReportNames.includes(reportDefinition.reportName);

export type DBArchiveCompanyCode = { value: string };
export type ArchiveCompanyCodes = DBArchiveCompanyCode[];
